export default {
  otherLegPrice (VueApp, leg) {
    let booking = VueApp.$store.state.booking
    let filters = booking.filters
    let airlines = booking.airlines
    if (!filters.departure.isReturning) return 0

    let chepeastPrice = this.findLowestNonZero(airlines.leg2.firstFlightPrice)
    if (leg === 'leg1') return chepeastPrice

    let selectedLeg = booking.selected.leg1
    if (Object.keys(selectedLeg).length) {
      let price = chepeastPrice
      return -(parseFloat(price.toFixed(2)))
    }
    return 0
  },

  findLowestNonZero (obj) {
    let lowest = Infinity;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key]
        if (value !== 0 && value < lowest) {
          lowest = value
        }
      }
    }
    return lowest === Infinity ? 0 : lowest
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/service-price.js